import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable, reaction} from 'mobx';
import {FormattedMessage, injectIntl} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import Slide from '@material-ui/core/Slide';
import CircularLoader from '../../../components/circularLoader/CircularLoader';
import DialogWrapper from '../../../components/dialog/Dialog';
import FormInput from '../../../components/FormHelpers/formField';
import MediaSelector from '../../../components/mediaSelector';
import {DeviceType, DialogTypes} from '../../../constants/enums';
import {isMobile} from '../../../utils/screenUtility';
import BaseButton from '../../../components/button/BaseButton';
import {isStudent} from '../../../utils/userUtility';
import './setProjectName.scss';

@injectIntl
@inject('dialogStore', 'projectStore')
@observer
class RenameProjectDialog extends Component {
    @observable projectName = '';

    componentDidMount() {
        this.nameListener = reaction(
            () => this.props.projectStore.activeProject,
            (project) => {
                if (project) {
                    this.setProjectName(project.name);
                }
            }, {fireImmediately:true}
        );
    }

    componentWillUnmount() {
        if (this.nameListener) {
            this.nameListener();
        }
    }

    @action setProjectName = (val) => {
        this.projectName = val;
    };

    handleChange = (name, val) => {
        this.setProjectName(val);
    };

    handleClose = () => {
        this.props.dialogStore.closeDialog(DialogTypes.RenameProject);
    };

    handleSave = async () => {
        const {projectStore} = this.props;
        await projectStore.saveProject(this.projectName, projectStore.activeProject, false);
        this.handleClose();
        projectStore.editProjectName(null, this.projectName);
    };

    render() {
        const {dialogStore, projectStore, intl: {formatMessage: translate}} = this.props;
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'up'},
            classes: {root: 'lesson-modal-root', paper: 'paper'},
            open: dialogStore.getDialogState(DialogTypes.RenameProject)
        };
        const type = isStudent() ? 'project' : (projectStore.activeProject && projectStore.activeProject.parentOwnerId ? 'assignment' : 'lesson');

        return (
            <DialogWrapper {...dialogProps}>
                <div className="change-project-name">
                    {projectStore.isFetchingSingleProject
                        ? <CircularLoader />
                        : <Fragment>
                            <button className="change-project-name-close" onClick={this.handleClose}>
                                <Close />
                            </button>
                            <h2 className="change-project-name-heading">
                                <FormattedMessage id={`looper.nameForm.${type}Rename`}/>
                            </h2>
                            <FormInput
                                type='text'
                                name='name'
                                inputPlaceholder={translate({id: `looper.nameForm.${type}Placeholder`})}
                                onChange={this.handleChange}
                                value={this.projectName}
                            />
                            <div className="change-project-name-actions">
                                <MediaSelector devices={[DeviceType.Desktop, DeviceType.Tablet]}>
                                    <BaseButton
                                        className="change-project-name-btn cancel"
                                        label={translate({id: 'general.cancel'})}
                                        type="button"
                                        onClick={this.handleClose} />
                                </MediaSelector>
                                <BaseButton
                                    disabled={!this.projectName || projectStore.isProcessing}
                                    className="change-project-name-btn save"
                                    label={translate({id: 'general.save'})}
                                    type="button"
                                    onClick={this.handleSave} />
                            </div>
                        </Fragment>
                    }
                </div>
            </DialogWrapper>
        );
    }
}

export default RenameProjectDialog;
